module.exports = __webpack_public_path__ + "img/logo.fd71f387.svg";